$(function () {

    var $numberInputs = $("input.spinner[type='number']"),
        toggleFilledClass = function () {
            var $input = $(this);

            $input.parent().toggleClass("filled", $input.val().length > 0);
        };

    $numberInputs.spinner({
        min: 0,
        numberFormat: "i",
        change: toggleFilledClass
    });

    $numberInputs.each(toggleFilledClass);
    $numberInputs.on("change", toggleFilledClass);
    $numberInputs.on("spinchange", toggleFilledClass);

    $numberInputs.on("focus", function () {
        $(this).parent().addClass("focused");
    });

    $numberInputs.on("blur", function () {
        $(this).parent().removeClass("focused");
    });
});
